import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { RewardsSummary as RewardsSummaryModel } from '@spike/loyalty-model';
import styles from './RewardsSummary.module.scss';

export interface RewardsSummaryProps {
    summary: RewardsSummaryModel;
}

const RewardsSummary: FunctionComponent<RewardsSummaryProps> = ({ summary }) => {
    const tooltipCopy = `Points are held for ${summary.holdPeriodDays} days before they're automatically converted into wallet credit.`;

    const pendingTitle = (
        <span className={styles.titleRow}>
            Pending Loyalty Points
            <Tooltip
                placement="top"
                content={<span className={styles.tooltipContent}>{tooltipCopy}</span>}
            >
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    className={styles.infoIcon}
                />
            </Tooltip>
        </span>
    );

    const pendingValue = (
        <span className={styles.pendingValue}>
            <span className={styles.bigValue}>{summary.pendingPoints.toLocaleString('en-US')}</span>
            <span className={styles.subLine}>Estimated Wallet Value: ${summary.estimatedWalletValue.toFixed(2)}</span>
        </span>
    );

    return (
        <div className={styles.row}>
            <MetricBox
                className={styles.card}
                title={pendingTitle}
                value={pendingValue}
            />
            <MetricBox
                className={styles.card}
                title="Lifetime Points Earned"
                value={summary.lifetimePoints.toLocaleString('en-US')}
            />
        </div>
    );
};

export default RewardsSummary;
